import apiClient from '../../../common/services/apiClient';

export const apiCallIds = {
  UPLOAD_FILE: 'UPLOAD_FILE',
};

export default {
  uploadFile: fileData => {
    return apiClient.post(`/file/upload`, fileData, {
      apiCallId: apiCallIds.UPLOAD_FILE,
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/files/api/index.js